import { Actions } from '../container/App';
import { getCMSConfig } from '../util/cms';
import {
    mountInteractionList,
    setPathfinderRoutingBusiness,
} from './interactionList';

/**
 * Mounts every interaction lists
 */
export const mountPathfinderModules = (actions: Actions) => {
    for (const levelId of Object.values(getCMSConfig().levelIds)) {
        const interactionList = mountInteractionList(levelId);

        if (!interactionList) {
            continue;
        }

        setPathfinderRoutingBusiness(interactionList, actions, levelId);
    }
};
